import {Align, ReactUiBase} from '@wonderlandengine/react-ui';
import {Column, MaterialContext, Text} from '@wonderlandengine/react-ui/components';
import React, {useState, useEffect} from 'react';
import profile from './utils/profile.js';

export const App = (props: {comp: WatchUI}) => {
    const [timeString, setTimeString] = useState('');

    const [username] = useState(profile.getUsername());

    useEffect(() => {
        const updateTime = () => {
            const now = new Date();
            const hours = (now.getHours() < 10 ? '0' : '') + now.getHours();
            const minutes = (now.getMinutes() < 10 ? '0' : '') + now.getMinutes();
            const seconds = (now.getSeconds() < 10 ? '0' : '') + now.getSeconds();
            setTimeString(`${hours}:${minutes}:${seconds}`);
        };

        const intervalId = setInterval(updateTime, 1000);
        return () => clearInterval(intervalId); // Cleanup interval on component unmount
    }, []);

    return (
        <MaterialContext.Provider value={props.comp}>
            <Column>
                <Text fontSize={50} alignSelf={Align.Center} textAlign="center">
                    {timeString}
                </Text>
                <Text fontSize={80} alignSelf={Align.Center} textAlign="center">
                    {username}
                </Text>
            </Column>
        </MaterialContext.Provider>
    );
};

export class WatchUI extends ReactUiBase {
    static TypeName = 'watch-ui';

    render() {
        return <App comp={this} />;
    }
}
